import React from 'react';
import styles from './HeroBanner.module.css';

interface HeroBannerProps {
  imageSrc: string;
  imageAlt?: string;
}

const HeroBanner: React.FC<HeroBannerProps> = ({
  imageSrc,
  imageAlt = 'Hero Banner',
}) => {
  return (
    <section className={styles.fullScreen}>
      <img src={imageSrc} alt={imageAlt} />
    </section>
  );
};

export default HeroBanner;
